export default __webpack_public_path__ + "static/2280-6f86842de4a8d2af763fc56804d4ba7a.gif";